import RequestAbstract from "./RequestAbstract";

export default class MedDiary extends RequestAbstract {
    get link() {
        return this.links.medDiary;
    }

    getMedDiary(id) {
        const arr = [
            { field: "id", op: "=", value: +id },
        ];

        return this.getAllFiltered([arr]);
    }
}
